import { CancelTokenSource } from 'axios';
import {
  CentralPoolingTestRegistrationSearchRequest,
  PoolTestkitOverviewResponseDto,
  PrintLabelDto,
  SendTestkitRegistrationRequest,
  SendTestkitRegistrationResponse,
  TestPoolingRegistrationSearchResult
} from 'ts-types/api.types';
import axios from './http';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/testkit`;

export const searchPoolTestKitRegistrations = (
    searchRequest: Partial<CentralPoolingTestRegistrationSearchRequest>,
    source: CancelTokenSource): Promise<Array<TestPoolingRegistrationSearchResult>> => {

  return axios
      .post(`${apiUri}/search/pool-registration/central`, searchRequest, {cancelToken: source.token})
      .then(response => response.data)
};

export const setPoolTestKitLaboratory = (
    poolTestKitId: number,
    laboratoryId: number,
    source: CancelTokenSource): Promise<String> => {

  return axios
      .post(`${apiUri}/pool-laboratory/${laboratoryId}`,
          {},
          {
            params: {poolTestKitId},
            cancelToken: source.token
          }
      )
      .then(response => response.data)
};

export const registerPoolTestkit = (
    testKitCode: string,
    mandateId: number,
    cancelSourceToken: CancelTokenSource): Promise<TestPoolingRegistrationSearchResult> => {

  return axios
      .post(`${apiUri}/pool`, {},
          {
            params: {
              centralPooling: "true",
              testKitCode,
              mandateId
            },
            cancelToken: cancelSourceToken.token
          }
      )
      .then(response => response.data);
};

export const sendPoolTestKits = (
    request: Partial<SendTestkitRegistrationRequest>,
    cancelSourceToken: CancelTokenSource): Promise<SendTestkitRegistrationResponse> => {

  return axios
      .post(`${apiUri}/pool/send`, request, {
        params: {
          centralPooling: "true"
        },
        cancelToken: cancelSourceToken.token
      })
      .then(response => response.data);
};

export const deletePoolTestKit = (
    poolTestId: number,
    cancelSourceToken: CancelTokenSource): Promise<string> => {

  return axios
      .delete(`${apiUri}/pool/${poolTestId}`, {
        params: {
          centralPooling: "true"
        },
        cancelToken: cancelSourceToken.token
      })
      .then(response => response.data);
};

export const getPoolTestKits = (
    poolTestId: number,
    cancelSourceToken: CancelTokenSource): Promise<PoolTestkitOverviewResponseDto> => {

  return axios
      .get(`${apiUri}/pool/${poolTestId}`, {
        params: {
          centralPooling: "true"
        },
        cancelToken: cancelSourceToken.token
      })
      .then(response => response.data);
};

export const addTestToCentralPool = (
    poolTestId: number,
    testKitCode: string,
    cancelSourceToken: CancelTokenSource): Promise<string> => {

  return axios
      .post(`${apiUri}/pool/${poolTestId}/test-kit`,
          {},
          {
            params: {
              centralPooling: "true",
              testKitCode
            },
            cancelToken: cancelSourceToken.token
          })
      .then(response => response.data);
};

export const removeTestFromCentralPool = (
    poolTestId: number,
    testKitCode: string,
    cancelSourceToken: CancelTokenSource): Promise<string> => {

  return axios
      .delete(`${apiUri}/pool/${poolTestId}/test-kit/${testKitCode}`, {
        params: {
          centralPooling: "true"
        },
        cancelToken: cancelSourceToken.token
      })
      .then(response => response.data);
};

export const printTestKitBarcodeLabel = (
    testKitCode: string, source: CancelTokenSource)
    : Promise<PrintLabelDto> => {

  return axios
      .get(
          `${apiUri}/print-test-barcode`,
          {
            params: {testKitCode: testKitCode},
            cancelToken: source.token
          }
      )
      .then((response) => response.data);
};

export const singularizePoolTest = (
    convidTestId: number,
    changedTestKitCodes: { [key: number]: string },
    mandateId: number,
    source: CancelTokenSource)
    : Promise<PrintLabelDto> => {

  return axios
      .post(
          `${apiUri}/singularize-pool-test`,
          changedTestKitCodes,
          {
            params: {covidTestId: convidTestId, mandateId: mandateId},
            cancelToken: source.token
          }
      )
      .then((response) => response.data);
};
